import { alphaNum, email, helpers, maxLength, minValue, numeric, required, requiredIf } from '@vuelidate/validators';
import i18n from '../config/i18n';

const { t } = i18n.global;

export function vRequired() {
  return helpers.withMessage(t('errors.required'), required);
}

export function vRequiredIf(isRequired: boolean) {
  return helpers.withMessage(t('errors.required'), requiredIf(isRequired));
}

export function vEmail() {
  return helpers.withMessage(t('errors.email'), email);
}

export function vNumeric() {
  return helpers.withMessage(t('errors.numeric'), numeric);
}
export function vMinValue(num: number) {
  return helpers.withMessage(t('errors.minValue', { num }), minValue(num));
}

function minLength(num: number) {
  return (value: any) => {
    return value.length >= num;
  };
}
export function vMinLength(num: number) {
  return helpers.withMessage(t('errors.minLengthItems', { num }), minLength(num));
}
export function vMaxLength(num: number) {
  return helpers.withMessage(t('errors.maxLengthItems', { num }), maxLength(num));
}

function requiredId(isRequired: boolean) {
  return (value: any) => {
    return isRequired ? (typeof value === 'number' && value > 0) : true;
  };
}
export function vRequiredIdIf(isRequired: boolean) {
  return helpers.withMessage(t('errors.required'), requiredId(isRequired));
}

export function vRequiredId() {
  return helpers.withMessage(t('errors.required'), requiredId(true));
}

export function vAlphaNum() {
  return helpers.withMessage(t('errors.alphaNum'), alphaNum);
}
